import client, { IDataResponse } from '../request'

export interface AppClient {
  id: string
  name: string
  shopify_store_id: string
  shopify_store_name: string
  role: 'staff' | 'owner' | 'admin'
  created_at: string
  updated_at: string
}

const getAll = '/admin/app-clients'

//swr
const get = (id: string) => {
  return `/admin/app-clients/${id}`
}

const toRow = (data: IDataResponse<AppClient>) => {
  if (data?.data?.length > 0) {
    return data.data.map((element) => {
      return {
        ...element,
        key: element.id,
      }
    })
  }

  return []
}

const toPaginate = (data: IDataResponse<AppClient>) => {
  return {
    total: data?.meta?.total ?? 0,
  }
}

const verifyEmail = (id: string, email: string) => {
  return client.post(`/admin/app-clients/${id}/verified-emails`, { email })
}

const AppClientService = {
  getAll,
  get,
  toRow,
  toPaginate,
  verifyEmail,
}

export default AppClientService
